module.exports = __webpack_public_path__ + "img/incidentInfoRed.7930527c.svg";